import { sort } from '@ember/object/computed';
import Component from '@glimmer/component';

/*
  attrs
    - contact
    - model - array of lineItems
*/

export default class TransactionsComponent extends Component {
  sortBy = ['transDate:desc'];
  @sort('args.model', 'sortBy') sortedLineItems;
}
